export default class Tracker {
	constructor() {
		this.modules = [];
		this.tasks = [];

		this.session = null;
		this.classroom = null;
		this.behavior = null;
		this.debug = false;
		this.skip = false;

		this.currentTask = null;
		this.time = null;
		this.mistakes = null;
		this.cardsExplored = new Set();

		// Current performance score
		this.performanceValue = 0;
		this.completedTasks = [];
		this.evaluatedTasks = {};
	}

	initTasks(modules, tasks) {
		this.modules = modules;
		this.tasks = tasks;
	}

	initSession(session, classroom, behavior, debug, skip, performance, completed, evaluated) {
		this.session = session;
		this.classroom = classroom;
		this.behavior = behavior;
		this.debug = debug;
		this.skip = skip;
		this.performanceValue = performance;
		this.completedTasks = completed;
		this.evaluatedTasks = evaluated;
	}

	submitResult(taskId, duration, mistakes, research, performance) {
		fetch("/api/submit_result/", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				taskId,
				duration,
				mistakes,
				research,
				performance
			})
		})
		.then(response => response.json())
		.then(data => {
			if (!data.success) {
				console.warn("Upload fail:", data.error);
			}
			else {
				this.performanceValue = data.performance;
			}
		});
	}

	// submitQuizFeedback(taskId, fun, instructive, interesting) {
	// 	fetch("/api/submit_quiz_feedback/", {
	// 		method: "POST",
	// 		headers: { "Content-Type": "application/json" },
	// 		body: JSON.stringify({
	// 			taskId,
	// 			fun,
	// 			instructive,
	// 			interesting
	// 		})
	// 	})
	// 	.then(response => response.json())
	// 	.then(data => {
	// 		if (!data.success) {
	// 			console.warn("Upload fail:", data.error);
	// 		}
	// 	});
	// }
	submitQuizFeedback(taskId, rate1, rate2, rate3, rate4, rate5, rate6, rate7, rate8) {
		fetch("/api/submit_quiz_feedback/", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				taskId,
				rate1, rate2, rate3, rate4, rate5, rate6, rate7, rate8
			})
		})
		.then(response => response.json())
		.then(data => {
			if (!data.success) {
				console.warn("Upload fail:", data.error);
			}
		});
	}

	submitQuestionFeedback(taskId, difficulty) {
		fetch("/api/submit_question_feedback/", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				taskId,
				difficulty
			})
		})
		.then(response => response.json())
		.then(data => {
			if (!data.success) {
				console.warn("Upload fail:", data.error);
			}
			else {
				this.performanceValue = data.performance;
			}
		});
	}


	onTaskStart(taskId) {
		this.currentTask = taskId;
		this.time = 0;
		this.mistakes = 0;
		this.cardsExplored.clear();
	}

	onTaskMistake() {
		this.mistakes += 1;
	}

	onTaskComplete(taskId, elapsedTime) {
		this.submitResult(taskId, elapsedTime, this.mistakes, this.cardsExplored.size, this.performance);
		// this.performance = 0;
		this.currentTask = "done";
		this.time = elapsedTime;
		this.completedTasks.push(taskId);
	}

	// onQuizFeedback(taskId, fun, instructive, interesting) {
	// 	this.submitQuizFeedback(taskId, fun, instructive, interesting);
	// 	this.evaluatedTasks[taskId] = [fun, instructive, interesting];
	// }
	onQuizFeedback(taskId, rate1, rate2, rate3, rate4, rate5, rate6, rate7, rate8) {
		this.submitQuizFeedback(taskId, rate1, rate2, rate3, rate4, rate5, rate6, rate7, rate8);
		this.evaluatedTasks[taskId] = [rate1, rate2, rate3, rate4, rate5, rate6, rate7, rate8];
	}

	onQuestionFeedback(taskId, difficulty) {
		this.submitQuestionFeedback(taskId, difficulty);
		this.evaluatedTasks[taskId] = difficulty;
	}

	onCardExplore(cardValue, firstView) {
		if (firstView) {
			this.cardsExplored.add(cardValue);
		}
	}


	get performance() {
		if (this.behavior == "ADAPTIVE") {
			return Math.round(this.performanceValue);
		}
		else if (this.behavior == "EASY") {
			return 0;
		}
		else if (this.behavior == "MEDIUM") {
			return 50;
		}
		else if (this.behavior == "HARD") {
			return 100;
		}
		else if (this.behavior == "RANDOM") {
			if (!this.currentTask) {
				return -1;
			}
			let key = this.session + this.currentTask;
			let cache = localStorage.getItem(key);
			if (/^-?\d+$/.test(cache)) {
				return parseInt(cache);
			}

			// -10 - 110, to ensure easy/med/hard have 33% each
			let random = Math.floor(Math.random() * 121) - 10;
			random = Math.max(0, Math.min(100, random));
			localStorage.setItem(key, random);
			return random;

			// const key = this.session + this.currentTask;
			// return Math.pow(this.getHash(key), 2) % 100;

			/*
			const category1 = ["m2_t1", "m2_t2b", "m2_t3", "m2_t4b", "m2_t6a", "m1_t1a", "m1_t1c", "m1_t3", "m3_t2a", "m3_t3", "m3_t4b"];
			const category2 = ["m2_t2a", "m2_t2c", "m2_t4a", "m2_t5", "m2_t6b", "m1_t1b", "m1_t2", "m3_t1", "m3_t2b", "m3_t4a", "m3_t5"];
			// Group 1
			if (this.classroom == "7K8M") {
				if (category1.includes(this.currentTask)) {
					return 0;
				}
				else if (category2.includes(this.currentTask)) {
					return 100;
				}
				else {
					return 50;
				}
			}
			// Group 2
			else if (this.classroom == "2KJ9") {
				if (category1.includes(this.currentTask)) {
					return 100;
				}
				else if (category2.includes(this.currentTask)) {
					return 0;
				}
				else {
					return 50;
				}
			}
			else {
				console.error("Unknown classroom:", this.classroom);
				return 50;
			}
			*/
		}
	}

	isEasy() {
		return (this.performance <= 30);
	}

	isHard() {
		return (this.performance >= 70);
	}

	isTaskComplete(taskId) {
		return this.completedTasks.includes(taskId);
	}

	isTaskEvaluated(taskId) {
		return true;
		// return !!this.evaluatedTasks[taskId];
	}


	getHash(string) {
		let hash = 0;
		for (let i = 0; i < string.length; i++) {
			let chr = string.charCodeAt(i);
			hash = ((hash << 5) - hash) + chr;
			hash |= 0; // Convert to 32bit integer
		}
		return hash;
	}
}
